module.exports = __webpack_public_path__ + "static/img/jungong2.0cd1d63f.png";